import { Component, ViewChild } from '@angular/core';
import { Location } from '@angular/common';
import { NavigationEnd, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { StatusBar, Style } from '@capacitor/status-bar';
import { environment } from '../environments/environment';
import { MainService } from './service/main.service';
import { MatSidenav } from '@angular/material/sidenav';
import { ApiUrls } from './apiRouts';
import { ToasterServiceService } from './service/toaster.service';
import { LocalStorageService } from './service/local-storage.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  title = 'Driver Detection';
  currentUrl: any;
  showMenu: boolean = false;
  showFooter: boolean = true;
  loginData: any = [];
  userTypeId: any;
  user_id: any;
  baseUrl = environment.imageURL;
  imageUrl: any;
  imageUrlApi: any = '';

  @ViewChild('sidenav') sidenav: MatSidenav | undefined;
  constructor(
    public route: Router,
    private location: Location,
    private mainService: MainService,
    private toasterService: ToasterServiceService,
    private localStorageService: LocalStorageService,
    private dialog: MatDialog,
  ) {
    StatusBar.setBackgroundColor({ color: "#24278d" }).catch(() => { });
    StatusBar.setStyle({ style: Style.Dark }).catch(() => { });
    this.imageUrl = 'assets/img/user_.jpg';
    this.route.events.subscribe((e) => {
      if (e instanceof NavigationEnd) {
        this.currentUrl = e.urlAfterRedirects;
        this.userTypeId = JSON.parse(this.localStorageService.getItem("loginData") || '{}').user_type_id;
        this.showFooter = (this.currentUrl.startsWith('/auth') || this.currentUrl == '/delete-account' || this.currentUrl == '/privacy-policy' || this.currentUrl == '/contact-us')
        if (e.url == '/' || e.url == '/dashboard') {
          this.showMenu = true;
        }
        else {
          this.showMenu = false;
        }
      }
    });
    this.user_id = JSON.parse(this.localStorageService.getItem("loginData") || '{}').user_id;
    this.loginData = JSON.parse(this.localStorageService.getItem("loginData") || '{}');
    if (this.loginData.image !== undefined && this.loginData.image !== null && this.loginData.image.length > 0) {
      this.imageUrlApi = this.baseUrl + this.loginData.image;
    }

    this.mainService.setProfileData().subscribe(res => {
      this.loginData = JSON.parse(this.localStorageService.getItem("loginData") || '{}');
      if (this.loginData.image !== undefined && this.loginData.image !== null && this.loginData.image.length > 0) {
        this.imageUrlApi = this.baseUrl + this.loginData.image;
      }
      this.userTypeId = JSON.parse(this.localStorageService.getItem("loginData") || '{}').user_type_id;
      this.user_id = JSON.parse(this.localStorageService.getItem("loginData") || '{}').user_id;
    })
  }

  logout() {
    // this.closeSideBar();
    // let fcm_token = this.localStorageService.getItem("firebaseToken") || "";
    // let data = {
    //   fcm_token: fcm_token
    // };
    // this.mainService.postApi(ApiUrls.userLogout, data, 1).subscribe((res: any) => {
    //   if (res.status === 1) {
    //     this.toasterService.toastSuccess("Logout Successfully");
    //     this.route.navigate(['/auth/login']);
    //     localStorage.clear();
    //     this.localStorageService.setData("firebaseToken", fcm_token);
    //   } else {
    //     this.toasterService.toastError('Logout Failed');
    //   }
    // });
    this.localStorageService.deleteAllData();
    this.route.navigate(['/auth/login']);
  }

 

  closeSideBar() {
    this.sidenav?.close();
  }
 
  toggleClick(flag: any) {
    if (flag) {
      this.sidenav?.toggle();
    }
    else {
      this.location.back();
    }
  }

}
